import { useEffect, useRef, useState } from "react";

import { PlaceholderImg } from "../../new-client-dashboard/common/placeholder";
import ContactPanelForTreatment from "../../TreatmentPage/components/ContactPanelForTreatment";
import TextPanel from "../../common/TextPanel";
import GenrateDocument from "../../GenrateDocument/GenrateDocument";
// import TreatmentNotesSection from "../../TreatmentPage/NotesTreatmentSection";
import VerifiedIcon from "../../../assets/verified_yes.png";
import NonVerifiedIcon from "../../../assets/verifiedno.png";
import InformationPanel from "../../common/InformationPanel";
import PanelActionBarComponent from "../../common/PanelActionBarComponent";
import { currencyFormat } from "../../../Utils/helper";
import TreatmentNotesSection from "../../TreatmentPage/NotesTreatmentSection";
import PlaceHolderifNothingAdded from "../../components-new-final/placeholder-nothing-added";

import EditPropertyDmg from "./modals/edit-property-dmg";
import "../../common/RecordPanel.css";

const PropertyDamageTab = ({ data, refetch, pageIcon = "", setAddPropertyDmgModal = () => {} }) => {
  const [showDocument, setShowDocument] = useState(false);
  const [instanceIdForGenrateDoc, setInstanceIdForGenragteDoc] = useState(null);
  const handleGenrateDocument = (instanceId) => {
    setInstanceIdForGenragteDoc(instanceId);
    setShowDocument(true);
  };

  const DogBiteLocBtn = [
    {
      id: "generate-document-button",
      iconClassName: "ic ic-15 ic-generate-document",
      buttonText: "Letter",
      className: "p-l-6 p-r-5",
      style: { height: "25px" },
      onClick: (id, name) => handleGenrateDocument(id, name),
    },
  ];

  const [hoveredIndex, setHoveredIndex] = useState(null);

  const dogBiteInfoBtns = [
    {
      id: "generate-document-button",
      iconClassName: "ic ic-19 ic-avatar has-avatar-icon has-cover-img m-l-5",
      imgSrc: hoveredIndex ? VerifiedIcon : NonVerifiedIcon,

      imgClassName: "ic ic-19 m-r-5",
      buttonText: "9/20/25 10:30 AM",
      className: "p-l-6 p-r-5",
      style: { height: "25px" },
      onHover: () => {
        setHoveredIndex(true);
      },
      onMouseLeave: () => {
        setHoveredIndex(null);
      },
      onClick: () => {
        setHoveredIndex(true);
      },
    },
  ];

  const statusBtn = [
    {
      id: "generate-document-button",

      buttonText: "Paid",
      className: "p-l-6 p-r-5",
      style: { height: "25px" },
      onHover: () => {},
      onMouseLeave: () => {},
      onClick: () => {},
    },
  ];

  const [editModal, setEditModal] = useState(false);
  const [height, setHeight] = useState(null);
  const insuranceHeightRef = useRef(null);

  // The rows mount when data arrives; changing ref.current does not rerun effects.
  useEffect(() => {
    if (insuranceHeightRef.current) {
      setHeight(insuranceHeightRef.current.clientHeight);
    }
  }, [data]);

  const [selectedData, setSelectedData] = useState(null);
  const handleEdit = (data) => {
    setEditModal(true);
    setSelectedData(data);
  };

  return (
    <>
      {data?.length === 0 && (
        <>
          <PlaceHolderifNothingAdded
            text1={"No Property Damage has been reported"}
            text2={"Click to Add"}
            pageIcon={pageIcon}
            onClick={() => setAddPropertyDmgModal(true)}
          />
        </>
      )}
      {data?.length > 0 &&
        data?.map((pd) => {
          return (
            <div key={pd?.id} className="record-panel">
              <PanelActionBarComponent
                compact
                // panelIconSrc={InsuranceIcon}
                object={pd}
                page_id={73}
                type={`${pd?.year ?? ""} ${pd?.make ?? ""} ${pd?.model ?? ""}`}
                name={`${pd?.entity_name ?? ""}`}
              />
              <div
                className="d-flex m-b-0 record-panel-body flex-wrap record-panel-body--photo"
                style={{
                  gap: "5px",
                }}
              >
                <div className="d-flex flex-wrap" style={{ gap: "5px", width: "100%" }}>
                  {/*  */}
                  <div className="leins-container-six " ref={insuranceHeightRef}>
                    <PlaceholderImg
                      height={150}
                      style={{
                        marginTop: "5px",
                      }}
                    />
                    <div className="min-w-260px-client">
                      <InformationPanel
                        panel_name={"Vehicle Information"}
                        labelClassName="font-weight-600"
                        // labelStyle={{  }}
                        labelStyle={{
                          maxWidth: "85%",
                          display: "-webkit-box",
                          WebkitBoxOrient: "vertical",
                          WebkitLineClamp: 1,
                          overflow: "hidden",
                          color: "var(--primary-25)",
                        }}
                        valueStyle={{
                          maxWidth: "100%",
                          display: "-webkit-box",
                          WebkitBoxOrient: "vertical",
                          WebkitLineClamp: 1,
                          overflow: "hidden",
                        }}
                        data={[
                          {
                            label: "Year, Make, Model",
                            value: `${pd?.year ?? ""} ${pd?.make ?? ""} ${pd?.model ?? ""}`.trim(),
                          },
                          {
                            label: "Mileage",
                            value: `${pd?.mileage ?? ""}`,
                          },
                          {
                            label: "Owned / Leased",
                            value: `${pd?.ownership ?? ""}`,
                          },
                          {
                            label: "Value",
                            value: pd?.value ? `${currencyFormat(pd?.value)}` : "",
                          },
                          {
                            label: "Owed",
                            value: pd?.amount_owed ? `${currencyFormat(pd?.amount_owed)}` : "",
                          },
                        ]}
                        onSelectReport={() => {
                          handleEdit(pd);
                        }}
                        hasBtn={true}
                        defaultLength={5}
                        buttonData={statusBtn}
                      />
                    </div>

                    <div className="min-w-260px-client">
                      <ContactPanelForTreatment
                        id={""}
                        panel_name="Vehicle Location"
                        className="m-b-0"
                        pageName={"Property Damage"}
                        websiteURL={pd?.vehicle_location?.website ?? ""}
                        name={pd?.vehicle_location?.name ?? ""}
                        address1={pd?.vehicle_location?.address1 ?? ""}
                        address2={pd?.vehicle_location?.address2 ?? ""}
                        city={pd?.vehicle_location?.city ?? ""}
                        state={pd?.vehicle_location?.state ?? ""}
                        zip_code={pd?.vehicle_location?.zip ?? ""}
                        phone_number={pd?.vehicle_location?.phone_number ?? ""}
                        email={pd?.vehicle_location?.email ?? ""}
                        fax_number={pd?.vehicle_location?.fax ?? ""}
                        onSelectObject={() => {
                          handleEdit(pd);
                        }}
                        buttonData={DogBiteLocBtn}
                        genrate_doc_address={0}
                        templateDropdownId={0}
                        templatePageId={73}
                      />
                    </div>

                    <div className="min-w-260px-client">
                      <TextPanel
                        object={{
                          statement_summary: pd?.damage_description,
                        }}
                        onSelect={() => {
                          handleEdit(pd);
                        }}
                        panel_name="Damage Description"
                        className="info-div-accident-statement-summary"
                        primaryText="Click to add Damage Description"
                      />
                    </div>
                    <div className="min-w-260px-client">
                      <TextPanel
                        onSelect={() => {
                          handleEdit(pd);
                        }}
                        object={{
                          statement_summary: pd?.additional_pd_expense,
                        }}
                        panel_name="Additional PD Expenses"
                        className="info-div-accident-statement-summary"
                        primaryText="Click to add Additional PD Expenses"
                      />
                    </div>
                    <div className="min-w-260px-client">
                      <InformationPanel
                        panel_name={"Insurance Responsible"}
                        labelClassName="font-weight-600"
                        // labelStyle={{ color: "var(--primary-25)" }}
                        labelStyle={{
                          maxWidth: "85%",
                          display: "-webkit-box",
                          WebkitBoxOrient: "vertical",
                          WebkitLineClamp: 1,
                          overflow: "hidden",
                          color: "var(--primary-25)",
                        }}
                        data={[
                          {
                            label: "Insured",
                            value: "",
                          },
                          {
                            label: "Company Name",
                            value: `${pd?.insurance?.company_contact?.name ?? ""}`,
                          },
                          {
                            label: "Claim #",
                            value: `${pd?.insurance?.claim_number ?? ""}`,
                          },
                          {
                            label: "",
                            value: "",
                          },
                          {
                            label: "",
                            value: "",
                          },
                        ]}
                        onSelectReport={() => {
                          handleEdit(pd);
                        }}
                        hasBtn={true}
                        defaultLength={5}
                        buttonData={dogBiteInfoBtns}
                      />
                    </div>
                  </div>
                  <div
                    className=""
                    style={{
                      flex: 1,
                      minHeight: "160px",
                      paddingRight: "0px",
                      scrollbarWidth: "none",
                      minWidth: "min(400px, 100%)",
                      maxHeight: height === null ? undefined : `${height}px`,
                    }}
                  >
                    <p className="menu-bar-style columnsTitle text-center">Notes</p>
                    <TreatmentNotesSection
                      record_id={pd.id}
                      instanceFor="Defendants"
                      entity_type="PropertyDamage"
                      module={"PropertyDamage"}
                      pagePanels={6}
                    />
                  </div>
                </div>
              </div>
              {/* <div className="d-flex documents-wrapper">
                <div className="col-12">

                  <DocumentRow showSaveToPage={false} clientProvider={pd} page_id={73} />
                </div>
              </div> */}
            </div>
          );
        })}

      {showDocument && (
        <GenrateDocument
          show={true}
          handleClose={() => setShowDocument(false)}
          PageEntity="Death"
          instanceId={instanceIdForGenrateDoc}
        />
      )}

      {editModal && (
        <EditPropertyDmg
          show={editModal}
          handleClose={() => setEditModal(false)}
          isEdit={true}
          selectedData={selectedData}
          refetch={refetch}
        />
      )}
    </>
  );
};

export default PropertyDamageTab;
